import { render, staticRenderFns } from "./NewPopupContentView.vue?vue&type=template&id=0f10aa06&scoped=true"
import script from "./NewPopupContentView.vue?vue&type=script&lang=js"
export * from "./NewPopupContentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f10aa06",
  null
  
)

export default component.exports